import { ref } from "@vue/composition-api"
import { shopsUseCase } from "../../usecases"
import useStore from '../useStore'

const useShopsList = () => {
    const list = ref([])
    const total = ref(0)
    const loading = ref(false)

    const {state} = useStore()

    const shopCategory = state.value.myShops.length && state.value.myShops[0].category

    const randomSeed = parseInt(Math.random() * 100)

    const getList = async (userId, filters, page) => {
        loading.value = true
        const result = await shopsUseCase.getShopsList(userId, filters, page, shopCategory, randomSeed)
        if(result && result.hits) {
            const {hits, totalShops} = result
            total.value = totalShops
            list.value = page === 1 ? hits : [...list.value, ...hits]
        }
        loading.value = false
    }

    return {
        list,
        total,
        loading,
        getList
    }
}

export default useShopsList